import React from "react";
import classNames from "classnames";

const LoadingSpinner = ({ size = "medium", message = "로딩 중..." }) => {
  const spinnerClasses = classNames("newyear-spinner", {
    "newyear-spinner--small": size === "small",
    "newyear-spinner--medium": size === "medium",
    "newyear-spinner--large": size === "large",
  });

  return (
    <div className={spinnerClasses}>
      <div className="newyear-spinner__circle" />
      {message && <span className="newyear-spinner__message">{message}</span>}
    </div>
  );
};

export default LoadingSpinner;
